import { Col, Row } from "reactstrap";
import AsyncSelectField from "@components/fields/react-select/async-select";
import GroupBy from "../../common/group-by";
import KPI from "../../common/kpi";
import useFilters from "@views/common/hooks/use-filter";
import { useFormContext } from "react-hook-form";

const Filter = () => {
    const {
        control,
        formState: { errors }
    } = useFormContext();

    const { loadAsyncOptions } = useFilters();

    return (
        <Row>
            <Col lg={6}>
                <AsyncSelectField
                    loadOptions={(value, callback) => {
                        loadAsyncOptions({
                            value,
                            callback,
                            type       : "csm",
                            context    : {},
                            statusCheck: false
                        });
                    }}
                    defaultOptions
                    id="csm"
                    isClearable
                    label="CSM"
                    name="csm"
                    control={control}
                    errors={errors}/>
            </Col>

            <Col lg={6}>
                <AsyncSelectField
                    loadOptions={(value, callback) => {
                        loadAsyncOptions({
                            value,
                            callback,
                            type       : "sdr",
                            context    : {},
                            statusCheck: false
                        });
                    }}
                    defaultOptions
                    id="sdr"
                    isClearable
                    label="SDR"
                    name="sdr"
                    control={control}
                    errors={errors}/>
            </Col>
            <Col lg={6}>
                <AsyncSelectField
                    loadOptions={(value, callback) => {
                        loadAsyncOptions({
                            value,
                            callback,
                            type       : "stages",
                            context    : {},
                            statusCheck: false
                        });
                    }}
                    defaultOptions
                    id="stage"
                    isClearable
                    label="Stage"
                    name="stage"
                    control={control}
                    errors={errors}/>
            </Col>
            <hr />
            <KPI kpiOptions={[{ label: "MRR", value: "mrr", disabled: true }]} />
            <hr className="mt-1" />
            <GroupBy
                groupByOptions={[
                    {
                        label: "CSM",
                        value: "csm"
                    },
                    {
                        label: "SDR",
                        value: "sdr"
                    },
                    {
                        label: "Company",
                        value: "company_name"
                    }
                ]}/>
        </Row>
    );
};

export default Filter;
